import { render, staticRenderFns } from "./BaseLogoFi.vue?vue&type=template&id=75df85f2&"
import script from "./BaseLogoFi.vue?vue&type=script&lang=ts&"
export * from "./BaseLogoFi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports